import getter from '../getter';
export default function getEntityDefaultRecordCreateComponent(entity) {
    const getterName = 'defaultRecordCreateComponent';
    const result = getter(entity, getterName);
    return result;
}
